import { useMutation } from 'react-query';
import request from '../../../../helpers/request';

const mutationFn = ({ intervalIds, blocked, errorMessage }) =>
  request.post(
    'Acceptance/lock_unlock_intervals',
    { intervalIds, blocked },
    errorMessage,
    'Error'
  );

export const useToggleBlockIntervals = (options) =>
  useMutation(mutationFn, {
    ...options,
    onSuccess: (data, variables) => {
      if (data !== 'Error' && options?.onSuccess) {
        options.onSuccess(data, variables);
      }
    },
  });
